"use client";

import React from 'react';
import Image from 'next/image';
import LogoTadm from './logo-tadm.png';

const TadmLogo = () => (
  <Image
    src={LogoTadm}
    alt="TADM Logo"
    width={100}
    height={100}
    className="h-full w-full object-contain"
    priority
  />
);

export default TadmLogo;
